import { convertNumberToWords } from './convertNumberToWords'

export const formatNumber = (
  number: number,
  easterEggMode?: boolean
): string => {
  if (easterEggMode) return convertNumberToWords(number)

  return Math.round(number)
    ?.toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}
